import * as yup from 'yup';

export interface ShareFormValues {
  email?: string;
  phone?: string;
  note?: string;
}

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const shareValidationSchema = yup.object({
  email: yup.string().email('Enter a valid email').required('Email'),
  phone: yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  note: yup.string(),
});
